// extracted by mini-css-extract-plugin
export default {"container":"VerifyCodePage_container__WXoke","linkResendCode":"VerifyCodePage_linkResendCode__QLNit","error":"VerifyCodePage_error__xbnQK"};